import script from "./NotificationItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationItem.vue?vue&type=script&setup=true&lang=ts"

import "./NotificationItem.vue?vue&type=style&index=0&id=6db92600&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6db92600"]])

export default __exports__